import { CompanyRole } from '../models/company.model';

/** Roles de negocio que conoce la web, en orden de jerarquía. */
export const COMPANY_ROLES: CompanyRole[] = ['owner', 'admin', 'staff'];

/** Etiqueta de cada rol de negocio (única fuente de verdad en la web). */
export const COMPANY_ROLE_LABELS: Record<CompanyRole, string> = {
  owner: 'Dueño',
  admin: 'Administrador',
  staff: 'Staff',
};

/** Descripción de respaldo cuando GET /company-roles no responde. */
export const COMPANY_ROLE_FALLBACK_DESCRIPTIONS: Record<CompanyRole, string> = {
  owner: 'Todo el negocio, incluido el equipo',
  admin: 'Todo el negocio en la web, menos el equipo',
  staff: 'Solo la app CradleRewards Console',
};

/** Clase del chip (cr-badge) de cada rol: dueño dorado, administrador teal, staff neutro. */
const COMPANY_ROLE_BADGES: Record<CompanyRole, string> = {
  owner: 'cr-badge--gold',
  admin: 'cr-badge--brand',
  staff: '',
};

export function isCompanyRole(role: string | null | undefined): role is CompanyRole {
  return !!role && (COMPANY_ROLES as string[]).includes(role);
}

/** Etiqueta del rol; '' si no hay rol (p. ej. sudo). */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return isCompanyRole(role) ? COMPANY_ROLE_LABELS[role] : role;
}

/** Clase del chip del rol. */
export function roleBadgeClass(role: string | null | undefined): string {
  return isCompanyRole(role) ? COMPANY_ROLE_BADGES[role] : '';
}

/** Dueño y Administrador usan la web; Staff solo la app CradleRewards Console. */
export function canUseWeb(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

/** Solo el dueño agrega, quita y cambia el rol de miembros e invitaciones (el sudo también, aparte). */
export function canManageMembers(role: string | null | undefined): boolean {
  return role === 'owner';
}
